package com.tixforgigs.common.ui.components.structure


import io.kvision.core.Container
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.panel.SimplePanel
import io.kvision.panel.simplePanel

@OptIn(ExperimentalMaterialApi::class)
fun Container.bodyPanel(
  init: (SimplePanel.() -> Unit)? = null
): SimplePanel = simplePanel(
  className = "xm-body",
  init = init
)
